export const productHeaderPremiumGql = /* GraphQL */ `
... on landingPageContent2023_productHeaderPremium_BlockType {
    typeHandle
    sectionTitle
    description
    heightOverride
    heightOverrideMobile
    links:lpProductHeaderPremiumLinks {
        ... on lpProductHeaderPremiumLinks_BlockType {
            linkStyle:lpProductHeaderPremiumLinkLinkStyle
            enableModal:lpProductHeaderPremiumEnableModal
            disclaimerFootnote:lpProductHeaderPremiumDisclaimerFootnote {
                ... on disclaimerFootnote_disclaimerFootnote_Entry {
                    content:disclaimercontent
                }
            }
            link:lpProductHeaderPremiumLink {
                ariaLabel
                customText
                url
                target
                text
                element {
                    title
                    ... on videos_Asset {
                        videoId
                        videoSource
                    }
                    ... on videoUploads_Asset {
                        videoUrl:url
                    }
                }
            }
        }
    }
    media {
        ... on images_Asset {
            __typename
            title
            uncropped1920w {
                srcset
                srcWebp
            }
        }
        ... on videoUploads_Asset {
            __typename
            url
            videoThumbnail {
                ... on images_Asset {
                    uncropped1920w {
                        srcWebp
                        srcset
                    }
                }
            }
        }
    }
}`;
